import userIcon from "./images/user-icon.svg";
import historyIcon from "./images/history-icon.svg";
import historyIcon2 from "./images/history-icon-2.svg";
import membershipIcon from "./images/membership-icon.svg";
import cartIcon from "./images/cart-icon.svg";
import pendingitemBg from "./images/pending-item-bg.jpg";
import newUser from "./images/new-user-icon.svg";
import upArrow from "./images/up-arrow.svg";
import downArrow from "./images/down-arrow.svg";
import messageIcon from "./images/message-icon.svg";
import bdFlag from "./images/bd-flag.svg";
import profileSmall from "./images/profile-small.png";
import editIcon from "./images/edit-icon.svg";
import viewIcon from "./images/view-icon.svg";
import deleteIcon from "./images/delete-icon.svg";
import blockIcon from "./images/block-icon.svg";
import whatsApp from "./images/whats-app.svg";
import messageBtn from "./images/message-btn.svg";
import emailBtn from "./images/email-btn.svg";
import crossSquire from "./images/close-square.svg";
import downArrowWhite from "./images/down-arrow-white.svg";
import searchWhiteIcon from "./images/search-white-icon.svg";
import hyperlinkIcon from "./images/hyperlink-icon.png";
import infoIcon from "./images/info-icon.svg";
import editIcon2 from "./images/edit-icon2.svg";
import lockIcon from "./images/lock-icon.svg";
import userProfileBg from "./images/user-profile-sitebar-bg.jpg";
import userProfile2 from "./images/user-profile2.jpg";
import editPhotoIcon from "./images/edit-photo-icon.svg";
import checkWhiteIcon from "./images/check-white-icon.svg";
import rejectWhiteIcon from "./images/reject-white-icon.svg";
import queueIcon from "./images/queue-icon.svg";
import pendingIcon from "./images/pending-icon.svg";
import cameraIcon from "./images/camera-icon.svg";
import eyeIcon from "./images/eye-icon.svg";
import editWhiteIcon from "./images/edit-white-icon.svg";
import pakistanFlag from "./images/pakistan-flag.svg";
import indiaFlag from "./images/india-flag.svg";
import nigeriaFlag from "./images/nigeria-flag.svg";
import moroccoFlag from "./images/morocco-flag.svg";
import advanceFilterIcon from "./images/advance-filter-icon.svg";
import eyeIconViolet from "./images/eye_icon.svg";
import eyeOffIcon from "./images/eye_off.svg";
import notificationBellIcon from "./images/notification-bell-icon.svg";
import headerSearchIcon from "./images/header_search-icon.svg";
import whiteLogo from "./images/white-logo.svg";
import sidebarCloseIcon from "./images/sidebar-close-icon.svg";
import selectCheckIcon from "./images/select-check-icon.svg";
import syneIcon from "./images/syne-icon.svg";
import leftArrowWhite from "./images/left-arrow-white.svg";
import ColorRightArrow from "./images/color-right-arrow.svg";
import checkGreenIcon from "./images/check-green-icon.svg";
import rejectCrossIcon from "./images/reject-cross-icon.svg";
import membershipPlanIcon from "./images/membership-plan-icon.svg";
import plusIconWhite from "./images/plus-icon-white.svg";

import dropdownIcon from "./images/dropdownicon.svg";
import datepickerIcon from "./images/datepickericon.svg";
import editProfileBasicInfo from "./images/editprofile_basicinfo.svg";
import editProfileEducation from "./images/editprofile_education.svg";
import editProfileFamilyDetails from "./images/editprofile_familydetails.svg";
import editProfileMale from "./images/editprofile_male.png";
import editProfileFemale from "./images/editprofile_female.png";
import editProfilePhysicalLifestyle from "./images/editprofile_physciallifestyle.svg";
import editProfileReligiousStatus from "./images/editprofile_religiousstatus.svg";
import editProfileDescription from "./images/editprofile_description.svg";
import changeButtonIcon from "./images/changebuttonicon.svg";
import approvedIcon from "./images/approvedicon.svg";
import matchPrefBasic from "./images/matchpref_basicinfo.svg";
import matchPrefBody from "./images/matchpref_bodypref.svg";
import matchPrefEducation from "./images/matchpref_education.svg";
import onlineGreenIcon from "./images/online-green-icon.svg";
import documentVerified from "./images/document-verified.png";
import trustBadgeIcon from "./images/trust-badge-icon.png";
import closeIcon from "./images/close_icon.svg";
import loginVideo from "./videos/login-video.mp4";
import clearSearchfield from "./images/search_clearfield.svg";
import searchCross from "./images/search_cross.svg";
import headerSearch from "./images/header_search.svg";
import dragHandle from "./images/drag-handle 1.svg";


const images = {
  headerSearch,
  searchCross,
  clearSearchfield,
  loginVideo,
  closeIcon,
  documentVerified,
  trustBadgeIcon,
  matchPrefBasic,
  matchPrefBody,
  matchPrefEducation,
  approvedIcon,
  changeButtonIcon,
  editProfileBasicInfo,
  editProfileEducation,
  editProfileFamilyDetails,
  editProfileMale,
  editProfileFemale,
  editProfilePhysicalLifestyle,
  editProfileReligiousStatus,
  editProfileDescription,
  datepickerIcon,
  dropdownIcon,
  userIcon,
  historyIcon,
  historyIcon2,
  membershipIcon,
  cartIcon,
  newUser,
  pendingitemBg,
  upArrow,
  downArrow,
  messageIcon,
  bdFlag,
  profileSmall,
  editIcon,
  viewIcon,
  deleteIcon,
  blockIcon,
  whatsApp,
  messageBtn,
  emailBtn,
  crossSquire,
  downArrowWhite,
  searchWhiteIcon,
  hyperlinkIcon,
  infoIcon,
  editIcon2,
  lockIcon,
  userProfileBg,
  userProfile2,
  editPhotoIcon,
  checkWhiteIcon,
  rejectWhiteIcon,
  queueIcon,
  pendingIcon,
  cameraIcon,
  eyeIcon,
  editWhiteIcon,
  eyeIconViolet,
  eyeOffIcon,
  pakistanFlag,
  indiaFlag,
  nigeriaFlag,
  moroccoFlag,
  advanceFilterIcon,
  notificationBellIcon,
  headerSearchIcon,
  whiteLogo,
  sidebarCloseIcon,
  selectCheckIcon,
  syneIcon,
  leftArrowWhite,
  ColorRightArrow,
  checkGreenIcon,
  rejectCrossIcon,
  membershipPlanIcon,
  plusIconWhite,
  onlineGreenIcon,
  dragHandle,
};

export default images;
